module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8FLYg"))).then(() => parcelRequire('j1Yqi'));